export class Error {
    error!: string;
}